export var FS_GATEWAY_HOST = process.env.CLOUD_RUN_GATEWAY_HOST || "";
export var API_PARAM;
(function (API_PARAM) {
    API_PARAM["BUSINESS_BRANCH_IDS"] = "business_branch_ids";
})(API_PARAM || (API_PARAM = {}));
export var DEVICES_EVENT;
(function (DEVICES_EVENT) {
    DEVICES_EVENT["REFRESH"] = "Devices.Refresh";
})(DEVICES_EVENT || (DEVICES_EVENT = {}));
